import {
  getJsonData,
  postFormData,
} from "../Services/AxoisInterceptorr";

export const createCreator = (
  data,
  setIsProgress,
  onSuccess,
  onError
) => {
  return postFormData(
    "/api/creators",
    data,
    setIsProgress,
    onSuccess,
    onError
  );
};

export const getCreators = (
  setIsProgress,
  onSuccess,
  onError
) => {
  return getJsonData(
    "/api/creators",
    setIsProgress,
    onSuccess,
    onError
  );
};